import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { CallbackModal } from '../../components/CallbackDesktopWidget/CallbackModal';
import { WidgetLoader } from '../../components/CallbackDesktopWidget/WidgetLoader';
import { WorkTimeFailure } from '../../components/CallbackDesktopWidget/WorkTimeFailure';
import { useWorkTime } from '../../hooks/useWorkTime';
import { ERequestStatus } from '../../types/request';
import { ThemeContext } from '../../utils/themeContext';
import { CallbackContentContainer } from './parts/CallbackContent';
export var CallbackWithRecommendationsWidget = function CallbackWithRecommendationsWidget(props) {
  var open = props.open,
      onClose = props.onClose,
      onRequestWorkTime = props.onRequestWorkTime,
      theme = props.theme;

  var _useWorkTime = useWorkTime({
    onRequestWorkTime: onRequestWorkTime,
    open: open
  }),
      workTime = _useWorkTime.workTime,
      status = _useWorkTime.status,
      requestWorkTime = _useWorkTime.requestWorkTime;

  return /*#__PURE__*/React.createElement(ThemeContext.Provider, {
    value: theme
  }, /*#__PURE__*/React.createElement(CallbackModal, {
    open: open,
    onClose: onClose
  }, status === ERequestStatus.Loading && /*#__PURE__*/React.createElement(WidgetLoader, null), status === ERequestStatus.Failure && /*#__PURE__*/React.createElement(WorkTimeFailure, {
    onConfirm: requestWorkTime
  }), status === ERequestStatus.Success && /*#__PURE__*/React.createElement(CallbackContentContainer, _extends({}, props, {
    workTime: workTime
  }))));
};